import Swiper from 'swiper';
import { Breakpoint } from '../../types/breakpoint';
import ContentSameSize from './content-same-size';
export default class SliderWithOnePerSlideMobile {
    static $sliders = $('.js__slider-with-one-per-slide-mobile');
    static swipers = [];
    static options = {
        centeredSlides: false,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 24,
        watchOverflow: true,
        on: {
            init: function () {
                ContentSameSize.init();
            },
        },
    };
    static init() {
        if (!this.$sliders.length) {
            return;
        }
        this.$sliders.each((index, slider) => {
            const mobileSpaceBetween = Number($(slider).data('mobile-space-between')) || this.options.spaceBetween || 24;
            const options = {
                ...this.options,
                spaceBetween: mobileSpaceBetween,
                ...{
                    breakpoints: {
                        [Breakpoint.lg]: {
                            slidesPerView: $(slider).data('desktop-slides-count') || 4,
                            spaceBetween: 0,
                            centeredSlides: false,
                        },
                    },
                },
            };
            this.swipers[index] = new Swiper(slider, options);
        });
    }
}
